// Generated by scripts/fetch-laws.ts from lawsofux.com and timsommer.be. Do not edit directly.
import type { Law } from "../types";

export const norvigsLaw: Law = {
  slug: "norvigs-law",
  title: "Norvig's Law",
  definition: "Any technology that surpasses 50% penetration will never double again (in any number of months).",
  category: "theory",
  color: "#be9df7",
  labels: ["product","cs"],
  copy: [],
  sources: ["https://www.timsommer.be/famous-laws-of-software-development/"],
  related: [],
};
